export default __webpack_public_path__ + "07e1a48adec2197fb604c01538ebc4ed.woff";